import i18n from "../i18n";
import StatusTag from "../components/ui-kit/tags/status-tag/status-tag";
import {
  CommercialTypeTag,
  GovernmentalTypeTag,
  IndustrialTypeTag,
  OtherTypeTag,
  ResidentialTypeTag,
  ServiceTypeTag,
} from "../components/ui-kit/tags/type-of-use-tag";

const statusTranslationKeys: Record<string, string> = {
  Vacant: "vacant",
  Occupied: "occupied",
  Booked: "booked",
  Rented: "rented",
  "Not Applicable": "notApplicable",
};

export const getStatusTranslationKey = (status: string): string =>
  statusTranslationKeys[status] ?? "other";

export const getStatusText = (status: string): string => {
  const key = getStatusTranslationKey(status);
  return key === "other" ? status : i18n.t(`status.${key}`);
};

export const renderStatusTag = (status: string, className?: string) => (
  <StatusTag
    status={getStatusTranslationKey(status)}
    text={getStatusText(status)}
    className={className}
  />
);

export const renderTypeOfUseTag = (typeOfUse: string, className?: string) => {
  switch (typeOfUse) {
    case "Industrial":
      return <IndustrialTypeTag className={className} />;
    case "Residential":
      return <ResidentialTypeTag className={className} />;
    case "Service":
      return <ServiceTypeTag className={className} />;
    case "Commercial":
      return <CommercialTypeTag className={className} />;
    case "Governmental":
      return <GovernmentalTypeTag className={className} />;
    default:
      return <OtherTypeTag text={typeOfUse} className={className} />;
  }
};
